// scrollToTop.js
// Utility function to scroll to the top of the page with style resets

const scrollToTop = () => {
  return new Promise((resolve) => {
    // Store original body height and scroll behavior
    const originalBodyStyle = document.body.style.cssText;
    const originalScrollBehavior = document.documentElement.style.scrollBehavior;

    // Temporarily set scroll behavior to auto (non-smooth) and body height to 100vh
    document.documentElement.style.scrollBehavior = 'auto';
    document.body.style.cssText = 'height: 100vh; overflow: hidden;';

    // Scroll to top
    window.scrollTo(0, 0);

    // Check if the page has scrolled to the top
    function checkScroll() {
      if (window.pageYOffset === 0) {
        // Restore original body style and scroll behavior
        document.body.style.cssText = originalBodyStyle;
        document.documentElement.style.scrollBehavior = originalScrollBehavior;
        resolve();
      } else {
        requestAnimationFrame(checkScroll);
      }
    }

    requestAnimationFrame(checkScroll);
  });
};

export default scrollToTop;
